import { render, staticRenderFns } from "./external-order.vue?vue&type=template&id=6b73db2c&"
import script from "./external-order.vue?vue&type=script&lang=js&"
export * from "./external-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports